/**
 * Dr. Salus - Reminder Service
 * API admin (cookie auth) para gerenciar lembretes WhatsApp do Dr. Salus.
 */
import api from '../global/api';

const BASE = '/api/dr-salus/reminders';

class ReminderService {
  async list(phone = null) {
    const params = phone ? { phone } : {};
    const response = await api.get(BASE, { params });
    return response.data;
  }

  async get(reminderId) {
    const response = await api.get(`${BASE}/${reminderId}`);
    return response.data;
  }

  async create(payload) {
    const response = await api.post(BASE, payload);
    return response.data;
  }

  async update(reminderId, updates) {
    const response = await api.put(`${BASE}/${reminderId}`, updates);
    return response.data;
  }

  async deactivate(reminderId) {
    const response = await api.delete(`${BASE}/${reminderId}`);
    return response.data;
  }

  async sendNow(reminderId) {
    const response = await api.post(`${BASE}/${reminderId}/send-now`);
    return response.data;
  }

  async getLogs(reminderId, limit = 30) {
    const response = await api.get(`${BASE}/${reminderId}/logs`, { params: { limit } });
    return response.data;
  }

  /** Detalhe do template (com variáveis declaradas e custom keys requeridas). */
  async getTemplateDetail(templateName) {
    const response = await api.get(`/api/dr-salus/templates/${templateName}`);
    return response.data;
  }
}

const reminderService = new ReminderService();
export default reminderService;
